<template>
  <main
    class="menus-index"
    v-background-color="$store.getters['ui/getBackgroundColor']"
    v-tiled-background-image="$store.getters['ui/getBackgroundImage']"
  >
    <MainHeader :hideBackButton="true"/>
    <section data-element='menu-container'>
      <div data-element="menu-card" v-background-image="{ imageUrl: foodMenuImageUrl }">
        <btn
          data-element="button"
          text="Food menu"
          :link="true"
          href="/menus/food"
          size="md"
          backgroundColor="#ffffff"
          textColor="#000000"
          :fontStyle="heading"
        />
      </div>
      <div data-element="menu-card" v-background-image="{ imageUrl: drinksMenuImageUrl }">
        <btn
          data-element="button"
          text="Drinks menu"
          :link="true"
          href="/menus/drinks"
          size="md"
          backgroundColor="#ffffff"
          textColor="#000000"
          :fontStyle="heading"
        />
      </div>
      <router-link
        :to="{ name: 'terms' }"
        target="_blank"
        data-element="terms-link"
        v-font-style="this.$store.getters['ui/getBodyCopyFontDetail']('normal')"
      >
        Terms and conditions
      </router-link>
    </section>
  </main>
</template>

<script>
  import MainHeader   from '@/components/ui/MainHeader';
  import Btn          from '@/components/ui/Btn';

  export default {
    name: 'menusindexpage',
    data () {
      return {

      }
    },
    components: {
      MainHeader,
      Btn
    },
    computed: {
      heading () {
        return this.$store.getters['ui/getHeadingFontDetail'];
      },
      site () {
        return this.$store.getters['getSite'];
      },
      foodMenuImageUrl () {
        return this.site &&
                this.site.foodMenuImage &&
                this.site.foodMenuImage.fields &&
                this.site.foodMenuImage.fields.file &&
                this.site.foodMenuImage.fields.file.url
      },
      drinksMenuImageUrl () {
        return this.site &&
                this.site.drinksMenuImage &&
                this.site.drinksMenuImage.fields &&
                this.site.drinksMenuImage.fields.file &&
                this.site.drinksMenuImage.fields.file.url
      }
    },
    methods: {
      async init () {
        this.$store.dispatch('checkNecessaryDataToProceed');
      }
    },
    created () {
      this.init();
    }
  }
</script>

<style lang="scss" scoped>

  @import '@/assets/scss/variables.scss';
  @import '@/assets/scss/helpers.scss';

  .menus-index {
    [data-element='menu-container'] {
      width: 100vw;
      height:calc(100vh - 56px);
      padding: 16px;
      [data-element='menu-card'] {
        width:100%;
        height:calc((100vh - 56px - (2 * 16px) - 48px) / 2);
        display:flex;
        &:first-child {
          margin-bottom:16px;
        }
        [data-element='button'] {
          align-items:flex-end;
          margin-bottom:16px;
        }
      }
    }
    [data-element='terms-link'] {
      color:#000;
      margin-top:16px;
      text-decoration:underline;
      font-size:12px;
      -webkit-tap-highlight-color:transparent;
    }
  }

</style>
